export default {
  category: {
    apply: 'Apply',
    unlock: 'Unlock',
    lock: 'Lock',
    clear: 'Clear',
    noResults: 'No results',
    noResultsMessage: `Your search "{searchValue}" didn't match with any value.`,
    cancel: 'Cancel',
    searchInfo: 'Search in {elements} elements',
    selectedItems: '{items, plural, one{# selected} other{# selected}}',
    all: 'All',
    search: 'Search'
  },
  chartLegend: {
    next: 'Next page',
    prev: 'Previous page'
  },
  featureSelection: {
    // Mode keys mirror the nebula.gl mode ids in FEATURE_SELECTION_MODES /
    // EDIT_MODES, lower-cased on the first character.
    drawPolygonMode: 'Polygon',
    drawRectangleMode: 'Rectangle',
    drawPolygonByDraggingMode: 'Lasso tool',
    drawCircleFromCenterMode: 'Circle',
    edit: 'Edit mask',
    clickToEdit: 'Click on the mask to edit it',
    clickToCreate: 'Click on the map to create a mask',
    selectTool: 'Select a {label}',
    selectMode: 'Select a mode',
    chooseSelectionMode: 'Choose a selection mode',
    applyMask: 'Apply mask',
    clearMask: 'Clear mask',
    removeMask: 'Remove mask',
    removeMeasurement: 'Remove measurement',
    removeMapObjects: 'Remove map objects',
    remove: 'Remove',
    polygon: 'Polygon',
    point: 'Point',
    lineString: 'Line',
    invalid: 'Invalid geometry'
  },
  histogram: {
    all: 'All',
    selectedItems: '{items} selected',
    clear: 'Clear'
  },
  pie: {
    clear: 'Clear',
    selectedItems: '{items, plural, one{# selected} other{# selected}}',
    allSelected: 'All'
  },
  range: {
    clear: 'Clear',
    minLimit: 'min limit',
    maxLimit: 'max limit',
    minValue: 'min value',
    maxValue: 'max value'
  },
  table: {
    rowsPerPage: 'Rows per page',
    of: '{from}–{to} of {count}'
  },
  timeSeries: {
    speed: 'Speed',
    clear: 'Clear'
  }
}
